import React from 'react';
import { Typography, Grid, Link } from '@material-ui/core';
import config from '../../config/config.json';

export default function (props) {
    const ejemplo = [
        [
            { campo: 'id', tipo: 'integer', valor: '3', descripcion: 'Identificador del servicio.' },
            { campo: 'servicio', tipo: 'string', valor: 'Sincronización de Estaciones Automáticas', descripcion: 'Nombre del servicio.' },
            { campo: 'descripcion', tipo: 'string', valor: 'Contamos con una plataforma de sincronización de datos meteorologicos de las estaciones automáticas de la provincia', descripcion: 'Detalles que los usuarios necesitan saber acerca del servicio.' },
            { campo: 'publico', tipo: 'string', valor: 'No', descripcion: 'Informa si el servicio es público o no.' },
            { campo: 'costo', tipo: 'decimal', valor: '???', descripcion: 'Costo del servicio.' },
            { campo: 'ruta_acceso', tipo: 'string', valor: '/weather', descripcion: 'Ruta de acceso al servicio.' },
        ],
        [
            { campo: 'id', tipo: '', valor: '3', descripcion: '' },
            { campo: 'servicio', tipo: '', valor: 'Sistema de Alerta Temprana', descripcion: '' },
            { campo: 'descripcion', tipo: '', valor: 'Guiamos a instituciones ante desastres meteorológicos', descripcion: '' },
            { campo: 'publico', tipo: '', valor: 'Si', descripcion: '' },
            { campo: 'costo', tipo: '', valor: '-', descripcion: '' },
            { campo: 'ruta_acceso', tipo: '', valor: '/sat', descripcion: '' },
        ],
    ];
    /**{
        "id": "7",
        "servicio": "Sistema de Alerta Temprana",
        "descripcion": "Guiamos a instituciones ante desastres meteorológicos",
        "publico": "Si",
        "costo": null,
        "ruta_acceso": "/sat"
    } */

    return (
        <>
            <Typography variant="h5" color="initial">
                <code>
                    Servicios
                </code>
            </Typography>
            <br />

            <Typography variant="subtitle2" color="initial">
                Servicios científicos-técnicos que brinda la entidad.
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/servicio</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/servicio`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/servicio
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve la lista de servicios ofrecidos por la entidad. si han sido creados; de lo contrario una lista vacía <code>[ ]</code>. Donde cada servicio es representado por un objeto.
            </Typography>
            <br />

            <Typography variant="h6" color="initial">
                Ejemplo: <br /> {/* Ejemplo de respuesta */}
                {/* con un Tabs de mui mostrar [cuerpo, cabecera] */}
            </Typography>
            <br />
            <pre>
                [
                {
                    ejemplo.map((item) => (
                        <>
                            <div>{`{`}</div>
                            {
                                item.map((subitem) => (
                                    <div><span className="pre-key">"{subitem.campo}"</span>: <span className="pre-value">"{subitem.valor}",</span></div>
                                ))
                            }
                            <div>{`}`},</div>
                        </>
                    ))
                }
                ]
            </pre>

            <Typography variant="subtitle1" color="initial">
                Cada objeto esta formado por:
            </Typography>
            <br />

            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ejemplo.map((item, index) => {
                            if (index == 0) {
                                return (
                                    item.map((subitem) => (
                                        <tr>
                                            <td>{subitem.campo}</td>
                                            <td>{subitem.tipo}</td>
                                            <td>{subitem.descripcion}</td>
                                        </tr>
                                    ))
                                )
                            }
                        })
                    }
                </tbody>
            </table>
            <br />

            {/* otro ejemplo de peticion */}
            <Typography variant="subtitle2" color="initial">
                <strong>
                    Obteniendo un servicio específico.
                </strong>
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/servicio/{`{`}identificador{`}`}</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/servicio/3`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/servicio/{`{`}identificador{`}`}
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve un servicio dado su <code>{`{ `}identificador{` }`}</code> si es que existe. Este servicio está representado por un objeto de la forma: <code>(ver tabla anterior)</code>.
            </Typography>
            <br />

            <Typography variant="subtitle1" color="initial">
                Ejemplo de url para obtener el servicio con identficador igual a 3: <br />
            </Typography>
            <br />

            <pre>
                {config.apiBaseUrl}/servicio/3
            </pre>
            <br />

            <Typography variant="subtitle1" color="initial">
                Respuesta: <br />
            </Typography>
            <br />
            <pre>
                {
                    ejemplo.map((item, index) => {
                        if (index == 0) {
                            return (
                                <>
                                    <div>{`{`}</div>
                                    {
                                        item.map((subitem) => (
                                            <div><span className="pre-key">"{subitem.campo}"</span>: <span className="pre-value">"{subitem.valor}",</span></div>
                                        ))
                                    }
                                    <div>{`}`}</div>
                                </>
                            )
                        }
                    })
                }
            </pre>
        </>
    )
}